// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__breakpoints__root"};


//////////////////
// WEBPACK FOOTER
// ./containers/breakpoints.css
// module id = 149
// module chunks = 0